export var PasswordLoginRequirement;
(function (PasswordLoginRequirement) {
    PasswordLoginRequirement["DISABLED"] = "disabled";
    PasswordLoginRequirement["ALLOWED"] = "allowed";
})(PasswordLoginRequirement || (PasswordLoginRequirement = {}));
